import script from "./FilterItems.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterItems.vue?vue&type=script&setup=true&lang=ts"

import "./FilterItems.vue?vue&type=style&index=0&id=04d703d4&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04d703d4"]])

export default __exports__